import { useParams } from 'react-router-dom';

import { AppUpdateLegalDocumentPage } from '~/components/pages/AppUpdateLegalDocumentPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { useNavigate } from '~/components/utils/Navigation';

export const AppUpdateLegalDocumentRoute: React.FC = () => {
  const { appId, legalDocumentId } = useParams();
  const navigate = useNavigate();

  if (!appId || !legalDocumentId) {
    navigate('/');

    return null;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppUpdateLegalDocumentPage
        appId={appId}
        legalDocumentId={legalDocumentId}
      />
    </DashboardTemplate>
  );
};
